import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check_2",
  "use": "icon-check_2-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol viewBox=\"0 0 16 13\" id=\"icon-check_2\">\n  <path id=\"icon-check_2_arrow_r\" class=\"cls-1\" d=\"M751.547,252.992l1.443,1.454-8.048,10.088h0l-1.442,1.454-1.441-1.454h0l-5.048-5.089,1.443-1.453,5.046,5.089Z\" transform=\"translate(-737 -253)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol